export default "__VITE_ASSET__CLV6JJk4__"